import { CircularCheckboxIndicator } from "@/components/ui/circular-checkbox";

type PermissionCheckboxProps = {
  checked: boolean;
  label: string;
  onChange: () => void;
};

export function PermissionCheckbox({ checked, label, onChange }: PermissionCheckboxProps) {
  return (
    <label className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 hover:bg-background">
      <input type="checkbox" className="sr-only" checked={checked} onChange={onChange} />
      <CircularCheckboxIndicator checked={checked} />
      <span className="text-sm">{label}</span>
    </label>
  );
}
